import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { toCommaNumber } from 'common/formatters';
import { ActionList, Input, PillList } from 'common/components';
import {
  intOnly,
  maxLength,
  maxValue,
  minValue,
  required,
} from 'common/form-validators';
import { onlyNumbers, limitDigits } from 'common/normalizers';
import { ACTIVITY_SIZE, ACTIVITY_TYPES } from 'common/constants';

class SourceField extends Component {
  state = {
    calculatedHarvest: 0,
  };

  componentDidMount() {
    const { selectedYield, fieldName } = this.props;
    if (selectedYield) {
      this.handleChangeYield(fieldName.value);
    }
  }

  componentDidUpdate(prevProps) {
    const { fieldName } = this.props;
    if (!fieldName.value) return;

    // update yield when fieldName.value (size) changes
    if (fieldName.value !== prevProps.fieldName.value) {
      this.handleChangeYield(fieldName.value);
    }
  }

  // validations
  binSizeMin = value =>
    minValue(value, ACTIVITY_SIZE.MIN)
      ? 'Quantity can not be zero Bushels'
      : undefined;
  binSizeMax = value =>
    maxValue(value, ACTIVITY_SIZE.MAX_BIN)
      ? `Quantity can not be more than ${toCommaNumber(
          ACTIVITY_SIZE.MAX_BIN
        )} Bushels`
      : undefined;
  otherNameMax = value => maxLength(value, ACTIVITY_SIZE.MAX_TITLE);

  // normlizers
  normalizeBinSize = value => limitDigits(onlyNumbers(value), 7, 2);

  // for Harvesting activity `Field` calculation
  handleChangeYield = str => {
    if (!str) {
      return;
    }

    const { changeValue, selectedYield } = this.props;
    const size = JSON.parse(str).size;
    const calculatedHarvest = Math.round(Number(size) * Number(selectedYield));
    changeValue('amount', calculatedHarvest);
    this.setState({ calculatedHarvest });
  };

  getSectionTitle = str =>
    str && (
      <h3 className={'text--subheader'}>
        {str}
        <sup>*</sup>
      </h3>
    );

  getActionBoxTitle = str => {
    const { isEdit } = this.props;
    const obj = JSON.parse(str);
    return (
      <strong>
        {obj.name}{' '}
        {obj.max && !isEdit ? (
          <span className={'text--label'}>(Max. {toCommaNumber(obj.max)})</span>
        ) : (
          ''
        )}
      </strong>
    );
  };

  getContent = option => {
    const { submitting } = this.props;
    const {
      result: { value },
    } = option;

    return (
      <Fragment>
        {value === 'custom' ? (
          <Fragment>
            <h4 className={'text--label'}>{option.label} *</h4>
            <Input
              name={option.result.key}
              disabled={submitting}
              validate={[required, this.otherNameMax]}
              theme={['tight']}
              validateOnChange={true}
            />
          </Fragment>
        ) : (
          this.getActionBoxTitle(value)
        )}

        {option.amount &&
          (option.amount === 'yield' && value ? (
            <Fragment>
              <div className="actionlist__row">
                <strong className="text--label__wrapper text--medium">
                  {toCommaNumber(JSON.parse(value).size)}
                  <span className="text--label">Acres</span>
                  <i className="text--small icon--x" />
                </strong>
                <Input
                  name="yield"
                  title="Yield"
                  disabled={submitting}
                  infoText="bu/ACRE"
                  validate={[required, intOnly]}
                  format={toCommaNumber}
                  normalize={this.normalizeBinSize}
                  theme={['tight']}
                  validateOnChange={true}
                  onBlur={() => {
                    this.handleChangeYield(value);
                  }}
                />
              </div>
              <footer className="actionlist__footer">
                Total Harvest Qty ={' '}
                <strong>
                  {toCommaNumber(this.state.calculatedHarvest)} bu
                </strong>
              </footer>
            </Fragment>
          ) : (
            <Input
              name="amount"
              disabled={submitting}
              infoText="Bushels"
              validate={[required, intOnly, this.binSizeMin, this.binSizeMax]}
              format={toCommaNumber}
              normalize={this.normalizeBinSize}
              theme={['tight']}
              validateOnChange={true}
            />
          ))}
      </Fragment>
    );
  };

  renderActionList = (option, idx) => {
    const { handleRemoveAction, id, selectedType } = this.props;
    const {
      result: { value, key },
    } = option;

    if (
      value &&
      (value !== 'custom' || (value === 'custom' && this.props[key]))
    ) {
      const content = this.getContent(option);
      // only enable field deletion for add activity and storage/delivery activities
      const showRemoveAction =
        id === 'add' ||
        selectedType === ACTIVITY_TYPES.STORAGE ||
        selectedType === ACTIVITY_TYPES.DELIVERY;
      const actions = showRemoveAction && [
        {
          icon: 'garbage',
          action: () => {
            handleRemoveAction({ key, value });
          },
        },
      ];

      return <ActionList key={idx} cards={[{ content, actions }]} />;
    } else {
      return null;
    }
  };

  render() {
    const { options } = this.props;
    return options.source ? (
      <fieldset className={'field'}>
        {this.getSectionTitle(options.sourceTitle)}
        {options.source.map(this.renderActionList)}
        <PillList theme={['add', 'secondary']} list={options.source} />
      </fieldset>
    ) : null;
  }
}

SourceField.propTypes = {
  submitting: PropTypes.bool,
  options: PropTypes.object,
  changeValue: PropTypes.func.isRequired,
  handleRemoveAction: PropTypes.func.isRequired,
  fieldName: PropTypes.object,
  selectedYield: PropTypes.string,
  selectedType: PropTypes.string,
  id: PropTypes.string,
  isEdit: PropTypes.bool,
};

SourceField.defaultProps = {
  isEdit: false,
};

export default SourceField;



// WEBPACK FOOTER //
// ./src/containers/ActivityForm/fields/SourceField.js